import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BaseURL } from "../../../../Reusable/BaseURL";
import { UserContext } from "../../../../Context/UserContext";
import { GatePassTypeSelectGPUpdDirect } from "./GatePassTypeSelectGPUpdDirect";
import { GatePassInTypeSelectGPUpdDirect } from "./GatePassInTypeSelectGPUpdDirect";
import MyInput from "../../../../Reusable/MyInput";
import { GatePassPartySelectGPUpdDirect } from "./GatePassPartySelectGPUpdDirect";
import MyTextarea from "../../../../Reusable/MyTextarea";
import Button from "../../../../Reusable/Button";
import DirectGPUpdateForm from "./DirectGPUpdateForm";

export default function UpdateDirectGp() {
  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
    setGatePassListData,
    gatePassListData,
    directGpUpdData,
    directGpUpdDataItems,
  } = useContext(UserContext);

  useEffect(() => {
    if (directGpUpdData) {
      setMobile(directGpUpdData.mobile_no || "")
      setVisitorName(directGpUpdData.person_name || "")
      setGateNo(directGpUpdData.gate_no || "")
      setRemark(directGpUpdData.remarks || "")
      setVehicleNo(directGpUpdData.vehicle_no || "")
    }
    gettingPartyFunc();
  }, [directGpUpdData.pass_items]);

  // GETTING PARTY NAME 
  const gettingPartyFunc =async()=>{
     const res = await fetch(`${BaseURL}/parties/${directGpUpdData.party_id}`, {
      headers: {
        Accept: "application/json", 
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginData.token}`,
      }

     })
     const data = await res.json()
     if(res.ok && data){
      setParty(data.data)
     }
  }

  const [gatePassType, setGatePassType] = useState("");
  const [gatePassOutType, setGatePassOutType] = useState("");
  const [gatePassInType, setGatePassInType] = useState("");
  const [gpRgp, setGpRgp] = useState("");
  const [gpNrgp, setGpNrgp] = useState("");
  const [gateNo, setGateNo] = useState("");
  const [choosePO, setChoosePO] = useState("");
  const [party, setParty] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [visitorName, setVisitorName] = useState("");
  const [mobile, setMobile] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [challan, setChallan] = useState("");
  const [partyDetail, setPartyDetail] = useState("");
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false); // set: true default imp.

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [myCachePartyId, setMyCachePartyId] = useState("");

  const navigate = useNavigate();
  // useEffect(()=>{getUnsavedItemList()},[])

  // GATE PASS : SET CACHE function
  async function setCacheFun() {
    const selectedData = {
      // "type": gatePassType.label || "",
      //   "subtype": gatePassInType.label || "",
      challan_no: challan || "",
      // "party_id": choosePO.party_id || "",
      gate_no: gateNo || "",
      vehicle_no: vehicleNo || "",
      person_name: visitorName || "",
      mobile_no: mobile || "",
      remarks: remark || "",
    };
    // return console.log("cache data", selectedData)
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    // const data = await response.json();
  }

  // GATE PASS : TYPE SET CACHE
  async function setCacheTypeFun(type) {
    const selectedData = { type: type.label };
    // return console.log("typpe", selectedData)
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // GATE PASS : Sub- TYPE SET CACHE
  async function setCacheInTypeFun(inType) {
    const inTypeLabel = inType.label || gatePassInType.label;
    const selectedData = { subtype: inTypeLabel };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // GATE PASS : po SET CACHE function
  async function setCachePOFun(po) {
    const selectedData = { party_id: po.party_id || po.value };
    const response = await fetch(`${BaseURL}/purchase/gp/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }

  // async function getUnsavedItemList() {
  //   // setInitialLoading(true);
  //   const res = await fetch(`${BaseURL}/purchase/gp/getcache`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then(async (createRes) => {
  //       if (createRes.status) {
  //         // const cacheItems = createRes.data.items || [];

  //         // setPOTypeCheck(createRes.data);
  //         const cacheItems =
  //           createRes.data !== null ? createRes.data.items : [];
  //         // const reverseCacheItems = cacheItems.reverse();
  //         // setUnsavedIndentItem(createRes.data.items || []);
  //         setUnsavedIndentItem(cacheItems);
  //         // await setIndentPOCache(cacheItems);

  //         // const mygetdivision = createRes.data?.items[0];
  //         // const cacheDivision = mygetdivision.division;
  //         // setMyCacheDivision(cacheDivision || "");

  //         // const mygetdivision =
  //         //   createRes.data !== null ? createRes.data?.items[0] : {};
  //         // const cacheDivision = mygetdivision?.division || "";
  //         // setMyCacheDivision(cacheDivision || "");

  //         if (createRes?.data?.items > 0) {
  //           // const myCacheDiv = createRes?.data?.division;
  //           // const myCacheDate = createRes?.data?.date;
  //           // setMyCacheDivision(myCacheDiv || "");
  //           // setDate(myCacheDate || "");
  //           const myCachePId = createRes?.data?.party_id;
  //           const myCacheChallan = createRes?.data?.challan_no;
  //           const myCacheType = createRes?.data?.type;
  //           const myCacheSubtype = createRes?.data?.subtype;
  //           const myCacheGateNo = createRes?.data?.gate_no;
  //           const myCacheVehicleNo = createRes?.data?.vehicle_no;
  //           const myCachePersonName = createRes?.data?.person_name;
  //           const myCacheMobile = createRes?.data?.mobile_no;
  //           const myCacheRemark = createRes?.data?.remarks;

  //           setMyCachePartyId(myCachePId || "");
  //           setChallan(myCacheChallan || "");
  //           setGatePassType(myCacheType || "");
  //           setGatePassInType(myCacheSubtype || "");
  //           setGateNo(myCacheGateNo || "");
  //           setVehicleNo(myCacheVehicleNo || "");
  //           setVisitorName(myCachePersonName || "");
  //           setMobile(myCacheMobile || "");
  //           setRemark(myCacheRemark || "");
  //         }
  //         setSpinner(false);
  //       }
  //       if (createRes.status || createRes.status === false) {
  //         // setInitialLoading(false);
  //         setSpinner(false);
  //       } else {
  //         // setInitialLoading(false);
  //         setSpinner(false);
  //       }
  //     });
  // }

  // START DIRECT GATE PASS CREATE
  async function createDirectGP(e) {
    e.preventDefault();
    const poItemIds = gatePassListData?.map((item) => item.id);
    // console.log("poItemIds", poItemIds)

    // if (gatePassListData.length <= 0) {
    //   toast.error("Please Choose PO list before submit.");
    //   return;
    // }
    setSubmitDisable(true);

    const formData = {
      type: gatePassType.label,
      subtype: gatePassInType.label,
      party_id: party.value,
      challan_no: challan,
      gate_no: gateNo,
      vehicle_no: vehicleNo,
      person_name: visitorName,
      mobile_no: mobile,
      remarks: remark,
    };

    const res = await fetch(`${BaseURL}/purchase/gp/createdirectpass`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");

          setGatePassType("");
          setGatePassInType("");
          setParty("");
          setGateNo("");
          setChallan("");
          setVehicleNo("");
          setVisitorName("");
          setMobile("");
          // setChoosePO("");
          // setDate("");
          setRemark("");

          // navigate("/purchase/indent-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.gate_no) {
          toast.error(createRes.error.message.gate_no);
        } else if (createRes?.error?.message.vehicle_no) {
          toast.error(createRes.error.message.vehicle_no);
        } else if (createRes?.error?.message.person_name) {
          toast.error(createRes.error.message.person_name);
        } else if (createRes?.error?.message.mobile_no) {
          toast.error(createRes.error.message.mobile_no);
        } else if (createRes?.error?.message.items) {
          toast.error(createRes.error.message.items);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }
  // END DIRECT GATE PASS CREATE

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");

    setGatePassType("");
    setGateNo("");
    setVehicleNo("");
    setVisitorName("");
    setMobile("");
    setChoosePO("");
    setDate("");
    setRemark("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  useEffect(() => {
    setGatePassListData([]);
    setChoosePO("");
  }, [gatePassType?.label]);

  // GET PARTY DETAIL FUNC
  const getPartyDetailFun = async (partyId) => {
    const res = await fetch(`${BaseURL}/parties/${partyId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await res.json();
    if (data.status) {
      setPartyDetail(data.data.name);
    } else {
      toast.error("Party Detail not found!");
    }
  };

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Update Direct Gate Pass(Direct with In)
          </div>
          <div className="mb-2">
            <div className="flex gap-x-2">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-2">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4">
                    {/* <div className="mb-2 w-full">
                      <label>
                        Type <span className="text-red-500 font-bold">*</span>
                      </label>
                      <GatePassTypeSelectGPUpdDirect
                        selectedOption={gatePassType}
                        setSelectedOption={setGatePassType}
                        setCacheTypeFun={setCacheTypeFun}
                        setParty={setParty}
                        setGatePassInType={setGatePassInType}
                        setGatePassOutType={setGatePassOutType}
                        setPartyDetail={setPartyDetail}
                        setGpRgp={setGpRgp}
                        setGpNrgp={setGpNrgp}
                      />
                    </div> */}
                    <MyInput
                      label="Type"
                      type="text"
                      value={
                        directGpUpdData.type ? directGpUpdData?.type : "Empty"
                      }
                      className="w-full"
                      readOnly
                    />
                    <MyInput
                      label="In Type"
                      type="text"
                      value={
                        directGpUpdData.subtype
                          ? directGpUpdData?.subtype
                          : "Empty"
                      }
                      className="w-full"
                      readOnly
                    />

                    {/* {gatePassType?.label === "IN" && (
                      <div className="mb-2 w-full">
                        <label>
                          In Type{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassInTypeSelectGPUpdDirect
                          selectedOption={gatePassInType}
                          setSelectedOption={setGatePassInType}
                          setCacheInTypeFun={setCacheInTypeFun}
                          setParty={setParty}
                          // setPartyDetail={setPartyDetail}
                          // setCachePOFun={setCachePOFun}
                          setChoosePO={setChoosePO}
                        />
                      </div>
                    )} */}

                    <MyInput
                      label="Gate No./Name"
                      type="text"
                      value={gateNo}
                      onChange={(e) => setGateNo(e.target.value)}
                      className="w-full"
                      // mendatory="*"
                      // onBlur={() => setCacheFun()}
                    />
                    <MyInput
                      label="Vehicle No."
                      type="text"
                      value={vehicleNo}
                      onChange={(e) => setVehicleNo(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      // onBlur={() => setCacheFun()}
                    />
                    <MyInput
                      label="Visitor Name"
                      type="text"
                      value={visitorName}
                      onChange={(e) => setVisitorName(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      // onBlur={() => setCacheFun()}
                    />
                    <MyInput
                      label="Mobile"
                      type="text"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="w-full"
                      mendatory="*"
                      // onBlur={() => setCacheFun()}
                    />

                    {/* {gatePassInType?.label === "Direct" && (
                      <div className="mb-2 w-full">
                        <label>
                          Party{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <GatePassPartySelectGPUpdDirect
                          selectedOption={party}
                          setSelectedOption={setParty}
                          setCachePOFun={setCachePOFun}
                        />
                      </div>
                    )} */}

                    <MyInput
                      label="Party"
                      type="text"
                      value={party.name}
                      className="w-full"
                      readOnly
                    />

                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onBlur={() => setCacheFun()}
                    />
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}
            </div>
          </div>

          {/* {gatePassInType?.label === "Direct" && party?.value && ( */}
            <DirectGPUpdateForm
              // partyId={party?.value}
              partyId={directGpUpdData.party_id}
              // setCacheInTypeFun={setCacheInTypeFun}
              // getUnsavedItemList={getUnsavedItemList}
              // setUnsavedIndentItem={setUnsavedIndentItem}
              // unsavedIndentItem={unsavedIndentItem}
              unsavedIndentItem={directGpUpdDataItems}
            />
          {/* )} */}

          {/* {submitAction === "submit" &&
            gatePassInType?.label === "Direct" &&
            party?.value && ( */}
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  type="submit"
                  // disabled={submitDisable || unsavedIndentItem.length <= 0}
                  disabled={submitDisable}
                  onClick={(e) => createDirectGP(e)}
                >
                  {submitDisable ? "Wait.." : "Update"}
                </Button>
                {/* <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button> */}
              </div>
            {/* )} */}
        </div>
      </div>
    </div>
  );
}
